import {Platform} from 'react-native';
import {WEB_APP_BASE_URL} from 'config/app.config';
import {setLoadingTrip} from 'components/World/loadingTrip';

export const getWebHomeUrl = () => {
  const raw = String(WEB_APP_BASE_URL || '').trim();
  return raw.replace(/\/$/, '');
};

export const redirectToWebHome = (options = {}) => {
  if (Platform.OS !== 'web') return;
  if (typeof window === 'undefined') return;
  const {replace = false} = options;
  const home = getWebHomeUrl();
  if (!home) return;
  // the loading screen names Home while this page goes (owner 13 Oct), never the world being left
  setLoadingTrip({to: 'home'});
  if (replace && window.location?.replace) window.location.replace(home);
  else window.location.href = home;
};

export const isQuikbaseContextOnWeb = (href) => {
  if (Platform.OS !== 'web') return false;
  if (typeof window === 'undefined') return false;

  try {
    const url = new URL(href || window.location.href);
    const worldToLoad = (url.searchParams.get('worldToLoad') || '').toLowerCase();
    const location = (url.searchParams.get('location') || '').toLowerCase();
    const world = (url.searchParams.get('world') || '').toLowerCase();
    return worldToLoad === 'quikbase' || location === 'quikbase' || world === 'quikbase';
  } catch (_) {
    return false;
  }
};

